import { Component, inject } from '@angular/core';
import { IconComponent } from '../../icon/icon.component';
import { ToastKind, ToastService } from '../../../core/services/toast.service';

const STYLES: Record<ToastKind, { icon: string; accent: string }> = {
  error: { icon: 'x-circle', accent: 'text-status-danger' },
  warning: { icon: 'alert-triangle', accent: 'text-status-warning' },
  success: { icon: 'check', accent: 'text-status-success' },
  info: { icon: 'info', accent: 'text-status-info' },
};

/** Stack of toasts in the bottom-right corner; mounted once in the app root. */
@Component({
  selector: 'pp-toast-container',
  standalone: true,
  imports: [IconComponent],
  templateUrl: './toast-container.component.html',
})
export class ToastContainerComponent {
  protected readonly toastService = inject(ToastService);
  protected readonly styles = STYLES;
}
